import React, { useState } from 'react';
import Box from '@mui/material/Box';

export default function PageLocalHistory() {

	return (
		<Box>
			<Box>History (pages)</Box>
		</Box>
	)
}

